// Generic «не удалось загрузить дашборд» view + retry.
// Используется OnboardingRouter'ом когда useDashboard завис на 5xx/network.
// Source: docs/specs/sprint-5/stage-4-frontend.md §4.9 + RF-S5-S4-17.

import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { Button } from '@/components/ui/button';
import { MobileFrame } from '@/components/layout/MobileFrame';

export function DashboardErrorView() {
  const qc = useQueryClient();

  const handleRetry = () => {
    void qc.invalidateQueries({ queryKey: queryKeys.dashboard });
  };

  return (
    <MobileFrame>
      <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center">
        <h2 className="text-base font-medium">Не удалось загрузить дашборд</h2>
        <p className="text-sm text-muted-foreground">
          Проверьте соединение и попробуйте снова.
        </p>
        <Button onClick={handleRetry}>Повторить</Button>
      </div>
    </MobileFrame>
  );
}
